// Content Types
export const CONTENT_TYPES = {
  PRODUCT: "product",
  PRODUCT_FAMILY: "productFamily",
  ARTICLE: "article",
  MEDIA: "mediaCollection",
  DOCUMENT: "document",
  WEBPAGE: "webpage",
  MATERIAL: "material",
  PATENT_FS: "foodservicePatent",
  PATENT_RETAIL: "retailPatent",
};

// Sort Options
export const SORT_OPTIONS = {
  ALPHABETICAL: "alphaAtoZ",
  MOST_RECENT: "mostRecent",
};

// Sort Values (for API parameters)
export const SORT_VALUES = {
  ALPHABETICAL: "alphaAtoZ",
  MOST_RECENT: "mostRecent",
};

// Filter Constants
export const FILTER_CONSTANTS = {
  CATEGORY_FILTER: "categories:",
  FILTERS_URL_PARAMETER_NAME: "filters",
  EXTENDED_FILTERS_URL_PARAMETER_NAME: "useExtendedFilters",
};

// Search Configuration
export const SEARCH_CONFIG = {
  NUMBER_TO_LOAD_MORE: 50,
  NUM_OF_ROWS: 50,
};
